import {DialogActions, DialogContent} from "@mui/material";
import React, {useState} from "react";
import {ActionButton} from "../../../../designSystem/components/ActionButton";

export const ReportForm = ({ handleSubmit }) => {
  const [formData, setFormData] = useState({
    visitRecord: '',
    contactTime: '',
    serviceTime: '',
    closureTime: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const isFormValid = formData.visitRecord && formData.contactTime && formData.serviceTime && formData.closureTime
  return (
    <React.Fragment>
      <DialogContent>
        <div className="space-y-4 w-full md:w-[400px] max-w-full">
          <div>
            <label className="block font-bold mb-2">
              訪視紀錄
            </label>
            <textarea
              name="visitRecord"
              value={formData.visitRecord}
              onChange={handleChange}
              className="w-full border rounded p-2"
              placeholder="請輸入"
              rows={5} // Adjust this number to control the height
            />
          </div>

          <div>
            <label className="block font-bold mb-2">
              聯繫病人時間：
            </label>
            <input
              type="datetime-local"
              name="contactTime"
              value={formData.contactTime}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>

          <div>
            <label className="block font-bold mb-2">
              到宅服務時間：
            </label>
            <input
              type="datetime-local"
              name="serviceTime"
              value={formData.serviceTime}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>

          <div>
            <label className="block font-bold mb-2">
              結案時間：
            </label>
            <input
              type="datetime-local"
              name="closureTime"
              value={formData.closureTime}
              onChange={handleChange}
              className="w-full border rounded p-2"
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="w-full p-4">
          <ActionButton
            fullWidth
            label="結案"
            iconName="fa-power-off"
            onClick={() => handleSubmit(formData)}
            disabled={!isFormValid}
          />
        </div>
      </DialogActions>
    </React.Fragment>
  );
};
